import { Component, OnInit, Inject } from '@angular/core';
import { WebStorageService, SESSION_STORAGE } from 'ngx-webstorage-service';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH } from '@okta/okta-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-common-header-section',
  templateUrl: './common-header-section.component.html',
  standalone: false
})
export class CommonHeaderSectionComponent  {

  constructor(@Inject(SESSION_STORAGE) public storage: WebStorageService, @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth, private readonly router: Router) { }

  async logout() {
    // Terminates the session with Okta and removes current tokens.
    this.storage.remove("acceptDisclaimer");
    this.storage.remove("contact");   
    this.storage.remove("oktaUser");   
    
    if(this.oktaAuth != null){
      this.oktaAuth.closeSession();
      await this.oktaAuth.signOut();
    }
    this.router.navigateByUrl('/logout');
  }

}
